import Vue from 'vue'
import App from '@/views/App.vue'
import router from '@/util/router.js'
import store from '@/util/store.js'
import ElementUI from 'element-ui'
import cookie from 'vue-cookie'

import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import '@/assets/fonts/iconfont.js'
import '@/assets/scss/reset.scss'
import axios from "@/util/axios.js"

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$cookie = cookie
Vue.prototype.$bus = new Vue()
Vue.prototype.$axios = axios;

//时间格式化
Date.prototype.format = function (fmt = "yyyy-MM-dd hh:mm:ss") {
  var o = {
    "M+": this.getMonth() + 2,               
    "d+": this.getDate() -1,                   
    "h+": this.getHours(),                   
    "m+": this.getMinutes(),                 
    "s+": this.getSeconds(),                 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds()//毫秒
  };
  //根据传入的年份格式，确定年份格式  RegExp.$1指匹配得到的第一个匹配的字符串
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  //遍历o的值，替换匹配的值，替换的时候根据匹配的格式截取数据格式
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
